import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useAuth } from '@/core/auth/AuthContext';
import { toast } from 'sonner';
import { equipmentRequestsDetailService } from '../services/equipmentRequestsDetail.service';

export function useEquipmentRequestsDetail() {
  const { id = '' } = useParams();
  const queryClient = useQueryClient();
  const { profile } = useAuth();
  const userId = profile?.id || '';
  const companyId = profile?.company_id || '';

  const query = useQuery({
    queryKey: ['equipment', 'requests', 'detail', id],
    queryFn: () => equipmentRequestsDetailService.getRequest(id, userId),
    enabled: !!id && !!userId,
  });

  const approveMutation = useMutation({
    mutationFn: () => equipmentRequestsDetailService.approveRequest(id, userId, companyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['equipment', 'requests'] });
      toast.success('Đã phê duyệt yêu cầu điều động');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Không thể phê duyệt');
    }
  });

  return {
    request: query.data,
    isLoading: query.isLoading,
    isApproving: approveMutation.isPending,
    approve: () => approveMutation.mutate(),
  };
}
